<template>
  <s-loader
    v-if="loading"
    class="charts-view__loader"
  />
  <b-container v-else fluid>
    <b-row class="mt-3">
      <b-col class="p-0">
        <accordion-panel
          :key="index"
          :id="accordion.title"
          v-for="(accordion, index) in accordions"
          :collapsed.sync="accordion.collapsed"
        >
          <b-row class="pl-3" slot="title">
            <strong>{{$t(accordion.title)}}</strong>
          </b-row>
          <div class="accordion__border">
            <b-row>
              <b-col
                v-for="(chart, index) in accordion.graphs"
                cols="12"
                lg="6"
                :key="index"
              >
                <default-triangle
                  v-if="chart.coordinates.length > 0"
                  :reference-coordinates="getTriangle1Coordinates"
                  :coordinates="chart.coordinates"
                  :type="chart.type"
                />
              </b-col>
            </b-row>
            <s-empty-list v-if="showEmptyList"/>
          </div>
        </accordion-panel>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import AccordionPanel from '@/components/AccordionPanel';
import comparativeAnalysisService from '@/domain/services/installation/engineering/chromatography/comparativeAnalysis';
import duvalTriangleCoordinates from '@/domain/services/installation/engineering/chromatography/duvalTriangleCoordinates';
import LoadingMixin from '@/services/loadingMixin';
import DefaultTriangle from './DefaultTriangle';

export default {
  components: {
    AccordionPanel,
    DefaultTriangle,
  },
  mixins: [LoadingMixin],
  data: () => ({
    triangles: [],
    accordions: [],
  }),
  methods: {
    getGraphs() {
      const { assetModuleId } = this.$route.params;
      const { sampleIds } = this.$route.query;
      this.startLoading();
      comparativeAnalysisService.getDuvalGraphs(assetModuleId, { sampleIds })
        .then((data) => {
          this.triangles = { ...data };
          this.createAccordions();
        }).finally(() => {
          this.endLoading();
        });
      },
    createAccordions() {
      this.accordions = [
        {
          title: 'enums.engineering.chromatography.rules.duval',
          graphs: this.trianglesObject,
          collapsed: false,
        },
      ];
    },
  },
  computed: {
    showEmptyList() {
      return Object.values(this.triangles).every(item => !item.length);
    },
    getTriangle1Coordinates() {
      return this.triangles.triangle1
        && this.triangles.triangle1.map(it => ({
          ...duvalTriangleCoordinates.getTriangle1Coordinates(it),
          name: it.sampleNumber,
        }));
    },
    getTriangle4Coordinates() {
      return this.triangles.triangle4
        && this.triangles.triangle4.map(it => ({
          ...duvalTriangleCoordinates.getTriangle4Coordinates(it),
          name: it.sampleNumber,
        }));
    },
    getTriangle5Coordinates() {
      return this.triangles.triangle5
        && this.triangles.triangle5.map(it => ({
          ...duvalTriangleCoordinates.getTriangle5Coordinates(it),
          name: it.sampleNumber,
        }));
    },
    mountTriangle1Object() {
      const coordinates = this.getTriangle1Coordinates;
      return {
        type: 'duval-triangle-1',
        coordinates,
      };
    },
    mountTriangle4Object() {
      const coordinates = this.getTriangle4Coordinates;
      return {
        type: 'duval-triangle-4',
        coordinates,
      };
    },
    mountTriangle5Object() {
      const coordinates = this.getTriangle5Coordinates;
      return {
        type: 'duval-triangle-5',
        coordinates,
      };
    },
    gasesObject() {
      return [];
    },
    trianglesObject() {
      return [
        this.mountTriangle1Object,
        this.mountTriangle4Object,
        this.mountTriangle5Object,
      ];
    },
  },
  created() {
    this.getGraphs();
  },
};
</script>
<style lang="sass" scoped>
  .charts-view
    &__loader
      font-size: 5em
      min-height: 500px
  .accordion
    &__border
      border: 1px solid var(--color-border-regular)
      border-radius: 5px
      padding: 1rem
      > div
        row-gap: 20px
  ::v-deep
    .accordion-panel__slot-container
      margin: 0.5rem 0 !important
</style>
